
export default {
  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleInput: function handleInput(value) {
      console.log(value);
      // eslint-disable-next-line vue/no-mutating-props
      this.formValue[this.config.prop] = value;
    }
  }
};